import React from "react";
import { COMB_LOGO_SRC } from "@/consts";
import { Flex, Image } from "antd";

interface PageLoadingProps {
  height?: number | string;
}
const PageLoading = ({ height }: PageLoadingProps) => {
  return (
    <Flex style={{ height: height || "100vh" }} justify="center" align="center">
      <Image width={40} alt="E/E Logo" src={COMB_LOGO_SRC} />
    </Flex>
  );
};

export default PageLoading;
